import { HttpService } from 'core/modules/network-service';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';
import { get } from 'lodash';

/*************************************************************/

/**
 * @type {class}
 * @desc MemberDetailsCommunicationHistoryActionLogWidget defines an HTTP service interface to send HTTP network requets.
 * @example
 * import { MemberDetailsCommunicationHistoryActionLogWidgetService } from 'services/memberDetailsCommunicationHistoryActionLogWidget';
 *
 * // create service instance and send/cancel request
 * const memberDetailsCommunicationHistoryActionLogWidgetService = new MemberDetailsCommunicationHistoryActionLogWidgetService();
 * const result = await memberDetailsCommunicationHistoryActionLogWidgetService.fetchData( '<user-id>' ); // fetch data
 * memberDetailsCommunicationHistoryActionLogWidgetService.cancel(); // cancel an active request
 */
export class MemberDetailsCommunicationHistoryActionLogWidgetService extends HttpService {

    // make request and fetch data
    async fetchComponentData( { data, url } ) {

        const response = await this.post( {
            host: CONFIG.host,
            path: url,
            data,
        } );

        return {
            status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.ERROR ),
            data: get( response, 'body.component', {} ),
        };
    }

    // format error response
    _errorFormatter( errResponse ) {
        return errResponse; // some logic
    }
}
